import { useEffect, useRef } from "react";

export default function VersionChecker() {
  const initialVersion = useRef(null);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch('/api/version');
        if (!res.ok) return;
        const data = await res.json();
        const current = data.version;

        if (!initialVersion.current) {
          initialVersion.current = current;
          return;
        }

        if (current !== initialVersion.current) {
          window.location.reload();
        }
      } catch {
        // Silencioso - si falla la red, no hacer nada
      }
    };

    check();
    const interval = setInterval(check, 2 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return null;
}
